import styled from 'styled-components';

import { fontStyles, palette } from 'theme';

const columnsMap = {
  dataSources: '230px 1fr 40px',
  dataObject: '5fr 10fr',
};
const getColumns = ({ $type, $amount }) => {
  if ($type && columnsMap[$type]) return columnsMap[$type];
  if ($amount === 2) return '1fr 40px';

  return '1fr';
};

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 15px;
  width: 100%;
  margin-bottom: 15px;
`;

export const Title = styled.p`
  ${fontStyles.textUpper}
  line-height: 44px;
  border: solid ${palette.black};
  border-width: 2px 0;
`;

export const Head = styled.div`
  display: grid;
  grid-template-columns: ${getColumns};
`;

export const HeadItem = styled.p`
  width: ${({ $isCentered }) => ($isCentered ? '100%' : 'fit-content')};
  ${fontStyles.smallText}
  color: ${palette.white};
  text-align: ${({ $isCentered }) => ($isCentered ? 'center' : 'left')};
  background-color: ${palette.black};
  padding: ${({ $isCentered }) => ($isCentered ? '2px 0 0' : '2px 5px 0')};
  ${({ $paddingTop }) => $paddingTop && `padding-top: ${$paddingTop}px;`}
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 5px;
`;

export const Item = styled.div`
  display: grid;
  grid-template-columns: ${getColumns};
`;

export const MobileWrap = styled.div`
  display: none;
  @media (max-width: 991px) {
    display: block;
    margin-bottom: 15px;
  }
`;
